import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import ExplorePage from "./ExplorePage";
import RecommendationPage from "./RecommendationPage";
import HousesPage from "./HousesPage";
import MyBlendsPage from "./MyBlendsPage";
import CalculatorPage from "./CalculatorPage";
import MarginBoardPage from "./MarginBoardPage";
import InventoryPage from "./InventoryPage";
import DiscoverPage from "./DiscoverPage";
import BlendDetailPage from "./BlendDetailPage";
import ScanPage from "./ScanPage";
import CatalogPage from "./CatalogPage";
import SimilarsPage from "./SimilarsPage";
import OrdersPage from "./OrdersPage";
import ReadinessPage from "./ReadinessPage";
import ReviewPage from "./ReviewPage";
import SuppliersPage from "./SuppliersPage";
import "./blend.css";

const TABS = [
  { to: "catalog", label: "الكتالوج", testId: "blend-tab-catalog" },
  { to: "orders", label: "🧾 الطلبات", testId: "blend-tab-orders" },
  { to: "readiness", label: "🚀 جاهزية الإطلاق", testId: "blend-tab-readiness" },
  { to: "review", label: "🗂 المراجعة", testId: "blend-tab-review" },
  { to: "suppliers", label: "🚚 الموردين", testId: "blend-tab-suppliers" },
  { to: "similars", label: "المتشابهات", testId: "blend-tab-similars" },
  { to: "explore", label: "استكشاف الأهداف", testId: "blend-tab-explore" },
  { to: "houses", label: "بيوت العطور", testId: "blend-tab-houses" },
  { to: "discover", label: "قرّبني من هدف", testId: "blend-tab-discover" },
  { to: "my-blends", label: "تركيباتي", testId: "blend-tab-myblends" },
  { to: "calculator", label: "حاسبة التشغيلة", testId: "blend-tab-calculator" },
  { to: "margin", label: "الهامش", testId: "blend-tab-margin" },
  { to: "inventory", label: "المخزون", testId: "blend-tab-inventory" },
  { to: "scan", label: "📷 امسح", testId: "blend-tab-scan" },
];

export default function BlendModule() {
  return (
    <div className="blend-root pb-8" data-testid="blend-module">
      <div className="px-4 pt-5">
        <div className="bl-eyebrow">ORVAN · مستشار التركيب</div>
        <h1 className="bl-title" style={{ fontSize: 26 }}>Blend Builder</h1>
        <p className="bl-sub mt-1">
          اختار هدف أو بيت عطور — والمحرّك يرشّحلك تركيبة جاهزة (أساس + اتجاه + مُعزّزات) بقواعد ثابتة.
        </p>
      </div>
      <div className="bl-tabs" data-testid="blend-tabs">
        {TABS.map((t) => (
          <NavLink key={t.to} to={`/pureh/blend/${t.to}`} data-testid={t.testId}
            className={({ isActive }) => `bl-tab ${isActive ? "active" : ""}`}>
            {t.label}
          </NavLink>
        ))}
      </div>
      <div className="px-4 pt-4">
        <Routes>
          <Route index element={<Navigate to="catalog" replace />} />
          <Route path="catalog" element={<CatalogPage />} />
          <Route path="similars" element={<SimilarsPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="readiness" element={<ReadinessPage />} />
          <Route path="review" element={<ReviewPage />} />
          <Route path="suppliers" element={<SuppliersPage />} />
          <Route path="explore" element={<ExplorePage />} />
          <Route path="houses" element={<HousesPage />} />
          <Route path="discover" element={<DiscoverPage />} />
          <Route path="target/:id" element={<RecommendationPage />} />
          <Route path="my-blends" element={<MyBlendsPage />} />
          <Route path="calculator" element={<CalculatorPage />} />
          <Route path="margin" element={<MarginBoardPage />} />
          <Route path="inventory" element={<InventoryPage />} />
          <Route path="detail/:id" element={<BlendDetailPage />} />
          <Route path="scan" element={<ScanPage />} />
          <Route path="scan/:code" element={<ScanPage />} />
        </Routes>
      </div>
    </div>
  );
}
